<script lang="ts" setup>
import UserStore from '@/store/UserStore'
import { copyToClipboard } from '@/helper/tools'

defineProps({
  userName: {
    type: String,
    default: ''
  }
})
</script>

<template>
  <div class="header__user" @click.ctrl.alt.shift.prevent="copyToClipboard(UserStore.contactId)">
    <i class="ic-user-circle header__icon" />
    <span
      class="header__name"
      data-hj-suppress
    >
      {{ userName }}</span>
    <br>
  </div>
</template>

<style lang="scss" scoped>
@import '@/assets/style/helpers/include-media';

.header {
  &__user {
    margin-left: auto;
    display: flex;
    align-items: center;
  }

  @include media('<tablet') {
    &__name {
      display: none;
    }
  }

  &__icon {
    font-size: rem-calc(24);
    margin-right: 0;

    @include media('>=tablet') {
      margin-right: rem-calc(12);
    }
  }

  a {
    color: #fff;
    text-decoration: none;
  }
}
</style>
